import { useEffect } from "react";
import { AccountLeadsStore } from "store/UserAccounts/UserAccount/AccountLeads/AccountLeads.store";
import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";

export const useGrsPendingLeadsGroup = (
  isEnabled: boolean,
  accountStore: UserAccountStore,
  accountLeadsStore: AccountLeadsStore
) => {
  const { accountGrsPendingLeadsStore } = accountStore;
  const isGrsGroupVisible =
    isEnabled && accountLeadsStore.isUnfilteredUnreadFirstPage;

  useEffect(() => {
    if (!isGrsGroupVisible) {
      accountGrsPendingLeadsStore.clearPendingLeads();
      return;
    }

    accountGrsPendingLeadsStore.fetchPendingLeads().catch(() => {
      console.error("Failed to load GRS pending leads");
    });

    return () => accountGrsPendingLeadsStore.clearPendingLeads();
  }, [isGrsGroupVisible, accountGrsPendingLeadsStore]);

  return isGrsGroupVisible;
};
